import { PersonalDetails } from "@/fetch/profiles";
import create from "zustand";
import { persist } from "zustand/middleware";

type CurrentPersonalDataState = {
  currentPersonalData: PersonalDetails | null | undefined;
  setCurrentPersonalData: (current: PersonalDetails | null | undefined) => void;
};

const useCurrentPersonalDataStore = create(
  persist<CurrentPersonalDataState>(
    (set) => ({
      currentPersonalData: null,
      setCurrentPersonalData: (currentPersonalData) =>
        set({ currentPersonalData }),
    }),
    {
      name: "current-personal-data",
    }
  )
);

const useCurrentPersonalData = () => {
  const { currentPersonalData, setCurrentPersonalData } =
    useCurrentPersonalDataStore();

  return { setCurrentPersonalData, currentPersonalData };
};

export default useCurrentPersonalData;
